import React from "react";
import PageTitle from "../components/title/PageTitle";

export default class LetterPanelHeader extends React.Component {
  render() {
    return (
      <div className="letter-panel-header">
        {typeof this.props.children === "string" ? <PageTitle title={this.props.children} /> : <PageTitle title={this.props.children[0]} />}
        {this.props.children}
      </div>
    );
  }
}
